import { render, staticRenderFns } from "./VaccinationPerCollaboratorPanel.vue?vue&type=template&id=e3fb03f2&scoped=true&"
import script from "./VaccinationPerCollaboratorPanel.vue?vue&type=script&lang=js&"
export * from "./VaccinationPerCollaboratorPanel.vue?vue&type=script&lang=js&"
import style0 from "./VaccinationPerCollaboratorPanel.vue?vue&type=style&index=0&id=e3fb03f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3fb03f2",
  null
  
)

export default component.exports